import { collectionEngineV1, IAM } from '../apis.js';
const collectionEngineAPI = collectionEngineV1('/tenants', false);
const reqIAM = IAM('/tenants', false);
export const createNewTenant = (newTenant) => collectionEngineAPI('POST', `/`, {
    body: newTenant,
});
export const patchTenantsCollectionEngine = (tenantId, patch) => collectionEngineAPI('PATCH', `/${tenantId}`, {
    body: patch,
});
export const getAll = async () => reqIAM('GET', '/?offset=0&limit=5000');
export const get = async (id) => reqIAM('GET', `/${id}`);
export const update = (id, tenant) => reqIAM('PATCH', `/${id}`, {
    body: tenant,
});
//# sourceMappingURL=tenants.js.map